import { render, staticRenderFns } from "./BookingEditTabInformation.vue?vue&type=template&id=e01865e6&"
import script from "./BookingEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./BookingEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./BookingEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports